module.exports = __webpack_public_path__ + "static/media/prinny-2.4bbacd39.svg";